export default "__VITE_ASSET__58ad8bcd__"